export const courseDescriptions = {

  // ─────────────────────────────────────────────
  // COMPTIA
  // ─────────────────────────────────────────────

  "comptiaa+": {
    description:
      "The CompTIA A+ certification is the industry standard for establishing a career in IT. It validates the skills needed to support today's core technologies, from security to cloud to data management and more. CompTIA A+ is the only industry-recognized credential with performance-based items to prove pros can think on their feet to perform critical IT support tasks.",
    learningObjectives: [
      "Install, configure, and troubleshoot PC hardware, mobile devices, and operating systems.",
      "Apply cybersecurity best practices, including malware identification and removal techniques.",
      "Manage and maintain wired and wireless networks in a professional environment.",
      "Support operational procedures, safety practices, and communication skills in an IT role.",
      "Troubleshoot real-world problems across multiple operating systems and environments.",
    ],
    entryRequirements:
      "No formal prerequisites are required to sit the CompTIA A+ exam. CompTIA recommends 9–12 months of hands-on experience in the lab or field prior to attempting the certification.",
    programRequirements: [
      { label: "Qualification Level:", value: "Entry-Level IT Certification" },
      { label: "Duration:", value: "3 to 6 months (self-paced or instructor-led)" },
      { label: "Study Options:", value: "Full-time, Part-time, or Self-Paced Online" },
      { label: "Prerequisites:", value: "None required; 9–12 months of practical IT experience recommended." },
    ],
  },

  "comptiacourses": {
    description:
      "CompTIA offers a comprehensive suite of vendor-neutral IT certifications that cover everything from foundational IT skills to advanced cybersecurity and cloud technologies. These globally recognised qualifications help IT professionals validate and grow their skills at every stage of their career. Ikusasa offers the full CompTIA certification pathway, from ITF+ through to advanced specialist certifications.",
    learningObjectives: [
      "Navigate the full CompTIA certification pathway from fundamentals to expert level.",
      "Build vendor-neutral skills applicable across all major technology platforms and vendors.",
      "Prepare for roles in IT support, networking, security, cloud, and data analytics.",
      "Understand industry best practices in infrastructure, cybersecurity, and emerging technologies.",
      "Earn globally recognised credentials that meet DoD 8570 and other compliance requirements.",
    ],
    entryRequirements:
      "Entry requirements vary by specific CompTIA certification. Most foundational courses have no prerequisites, while advanced certifications require prior CompTIA credentials or equivalent work experience.",
    programRequirements: [
      { label: "Qualification Level:", value: "Varies by course (Foundational to Expert)" },
      { label: "Duration:", value: "1 week to 6 months depending on certification level" },
      { label: "Study Options:", value: "Instructor-Led, Online Self-Paced, or Blended Learning" },
      { label: "Prerequisites:", value: "Varies by certification; see individual course pages for details." },
    ],
  },

  "cmptian+": {
    description:
      "CompTIA Network+ validates the essential knowledge and skills needed to design, configure, manage, and troubleshoot any wired and wireless network devices. It is the only certification that covers the specific skills that network professionals need to support today's complex hybrid environments. CompTIA Network+ is the most widely adopted, vendor-neutral networking certification in the world.",
    learningObjectives: [
      "Design and implement functional networks, including network components and their roles.",
      "Configure, manage, and maintain essential network devices using appropriate tools.",
      "Implement network security, standards, and protocols in a hybrid environment.",
      "Troubleshoot network connectivity issues in a timely and efficient manner.",
      "Understand emerging technologies including cloud computing, virtualization, and IoT.",
    ],
    entryRequirements:
      "CompTIA recommends having the CompTIA A+ certification and at least 9–12 months of networking experience prior to taking the Network+ exam.",
    programRequirements: [
      { label: "Qualification Level:", value: "Associate-Level IT Certification" },
      { label: "Duration:", value: "3 to 6 months" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "CompTIA A+ recommended; 9–12 months of hands-on networking experience." },
    ],
  },

  "comptiacybersec": {
    description:
      "CompTIA CySA+ (Cybersecurity Analyst) is an IT workforce certification that applies behavioural analytics to networks and devices to prevent, detect, and combat cybersecurity threats. CySA+ sits in the middle of the security certification pathway and is the only intermediate high-stakes cybersecurity analyst certification with both hands-on, performance-based questions and multiple-choice questions.",
    learningObjectives: [
      "Leverage intelligence and threat detection techniques to identify and respond to threats.",
      "Analyse and interpret data to identify vulnerabilities, risks, and non-compliance.",
      "Implement security solutions for cloud and hybrid environments.",
      "Use incident response processes to address security events effectively.",
      "Apply security frameworks and policies to support organisational risk management.",
    ],
    entryRequirements:
      "CompTIA recommends CompTIA Security+ or equivalent knowledge, plus 3–4 years of hands-on experience performing information security analyst job tasks.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate Professional Certification" },
      { label: "Duration:", value: "3 to 6 months" },
      { label: "Study Options:", value: "Instructor-Led, Blended, or Self-Paced Online" },
      { label: "Prerequisites:", value: "CompTIA Security+ or equivalent; 3–4 years of IT security experience recommended." },
    ],
  },

  "comptiafundamentals": {
    description:
      "CompTIA IT Fundamentals+ (ITF+) is a pre-career certification designed to help individuals decide if a career in IT is right for them. ITF+ is the only foundational IT certification that covers the basic IT skills and knowledge needed to perform tasks commonly performed by advanced end-users and to help individuals decide if they want to pursue a career in IT.",
    learningObjectives: [
      "Understand fundamental IT concepts, terminology, and infrastructure components.",
      "Identify types of software, their development approaches, and uses in a business context.",
      "Apply basic database and programming literacy in real-world scenarios.",
      "Implement basic security and data management best practices.",
      "Determine whether an IT career path aligns with your interests and abilities.",
    ],
    entryRequirements:
      "There are no prerequisites for CompTIA ITF+. This course is designed for absolute beginners with no prior IT experience or knowledge.",
    programRequirements: [
      { label: "Qualification Level:", value: "Foundational / Pre-Career Certification" },
      { label: "Duration:", value: "1 to 3 months" },
      { label: "Study Options:", value: "Self-Paced Online or Instructor-Led" },
      { label: "Prerequisites:", value: "None. Suitable for absolute beginners." },
    ],
  },

  "comptiainfrastructure": {
    description:
      "CompTIA's Infrastructure pathway covers the skills required to manage and support IT infrastructure, encompassing CompTIA Server+ and CompTIA Cloud+. These certifications validate expertise in server hardware, virtualisation, storage, security, and cloud technologies, preparing professionals for roles in data centre management and cloud operations.",
    learningObjectives: [
      "Install, configure, and maintain server hardware and software in an enterprise environment.",
      "Implement virtualisation and cloud technologies within IT infrastructure.",
      "Manage storage, disaster recovery, and high-availability systems.",
      "Troubleshoot infrastructure issues across physical, virtual, and cloud environments.",
      "Apply security practices to protect server, cloud, and network infrastructure.",
    ],
    entryRequirements:
      "CompTIA recommends CompTIA A+ and Network+ certifications, along with 18–24 months of IT administration experience, before pursuing infrastructure-level certifications.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate to Advanced Professional Certification" },
      { label: "Duration:", value: "3 to 6 months" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "CompTIA A+ and Network+ recommended; 18–24 months of IT experience." },
    ],
  },

  // ─────────────────────────────────────────────
  // CISCO
  // ─────────────────────────────────────────────

  "ciscoccna": {
    description:
      "The Cisco Certified Network Associate (CCNA) certification validates a broad range of fundamentals for all IT careers, covering network access, IP connectivity, IP services, security fundamentals, automation, and programmability. The CCNA is one of the most respected entry- to associate-level networking certifications in the world, recognised by employers globally.",
    learningObjectives: [
      "Configure, verify, and troubleshoot Ethernet switching and routing in an enterprise network.",
      "Implement and verify IPv4 and IPv6 addressing, subnetting, and connectivity.",
      "Configure and verify network services including DHCP, DNS, and NAT.",
      "Apply security fundamentals including access control lists and device hardening.",
      "Understand network automation, programmability, and basic Python scripting concepts.",
    ],
    entryRequirements:
      "There are no formal prerequisites for the CCNA exam. Cisco recommends one or more years of experience implementing and administering Cisco solutions, along with a basic understanding of IP addressing.",
    programRequirements: [
      { label: "Qualification Level:", value: "Associate-Level Cisco Certification" },
      { label: "Duration:", value: "3 to 6 months" },
      { label: "Study Options:", value: "Instructor-Led, Self-Paced Online, or Blended Learning" },
      { label: "Prerequisites:", value: "None required; basic networking knowledge and IP addressing recommended." },
    ],
  },

  "ciscoccnp": {
    description:
      "The Cisco Certified Network Professional (CCNP) Enterprise certification validates advanced skills in enterprise networking solutions, including design, implementation, operation, and troubleshooting. CCNP Enterprise now requires one core exam and one concentration exam of your choice, allowing professionals to specialise in the areas most relevant to their role.",
    learningObjectives: [
      "Design and implement advanced enterprise network architectures including SD-WAN and SD-Access.",
      "Configure and troubleshoot advanced routing protocols such as OSPF, BGP, and EIGRP.",
      "Implement network assurance, automation, and programmability in enterprise environments.",
      "Deploy and manage virtualisation technologies in enterprise network infrastructure.",
      "Troubleshoot complex enterprise network issues across physical and software-defined networks.",
    ],
    entryRequirements:
      "There are no formal prerequisites for CCNP Enterprise exams. Cisco recommends three to five years of experience with enterprise networking solutions before attempting the certification.",
    programRequirements: [
      { label: "Qualification Level:", value: "Professional-Level Cisco Certification" },
      { label: "Duration:", value: "6 to 12 months" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "No formal requirements; CCNA and 3–5 years of enterprise networking experience strongly recommended." },
    ],
  },

  "ciscocybersec": {
    description:
      "Cisco CyberOps certifications validate skills required for Security Operations Centre (SOC) roles, covering security monitoring, host-based analysis, network intrusion analysis, and security policies. The curriculum aligns with real-world SOC job functions and prepares candidates for Cisco's CyberOps Associate and Professional certifications.",
    learningObjectives: [
      "Monitor and analyse network traffic to identify and respond to security incidents.",
      "Perform host-based analysis to detect and investigate potential intrusions.",
      "Understand and apply security policies, procedures, and compliance frameworks.",
      "Use security tools and platforms including SIEM, IDS/IPS, and threat intelligence feeds.",
      "Conduct incident response activities in alignment with industry standards.",
    ],
    entryRequirements:
      "A basic understanding of networking, operating systems, and security concepts is recommended. CCNA-level knowledge is beneficial for those pursuing the CyberOps Professional certification.",
    programRequirements: [
      { label: "Qualification Level:", value: "Associate to Professional-Level Cisco Certification" },
      { label: "Duration:", value: "3 to 6 months" },
      { label: "Study Options:", value: "Instructor-Led or Online Self-Paced" },
      { label: "Prerequisites:", value: "Basic networking and security knowledge recommended; CCNA advantageous for professional level." },
    ],
  },

  "ciscodatacience": {
    description:
      "Cisco's data science and analytics training equips IT and data professionals with the skills to collect, analyse, and interpret large datasets to drive business decisions. Offered through the Cisco Networking Academy in partnership with leading data science platforms, these courses cover data analysis, machine learning, Python programming, and visualisation techniques.",
    learningObjectives: [
      "Apply Python programming to data manipulation, analysis, and visualisation tasks.",
      "Use statistical methods and machine learning algorithms to derive insights from data.",
      "Clean, transform, and manage large datasets using industry-standard tools.",
      "Build and evaluate predictive models using supervised and unsupervised learning techniques.",
      "Communicate data findings effectively using visualisation tools and storytelling techniques.",
    ],
    entryRequirements:
      "Basic programming knowledge and an understanding of mathematics and statistics are recommended. No prior data science experience is required for foundational courses.",
    programRequirements: [
      { label: "Qualification Level:", value: "Foundational to Intermediate Professional Development" },
      { label: "Duration:", value: "3 to 6 months" },
      { label: "Study Options:", value: "Online Self-Paced via Cisco NetAcad" },
      { label: "Prerequisites:", value: "Basic programming and mathematics knowledge recommended." },
    ],
  },

  "ciscofirepower": {
    description:
      "Cisco Firepower Threat Defence (FTD) training covers the configuration, management, and troubleshooting of Cisco's next-generation firewall (NGFW) and intrusion prevention system (IPS) solutions. This training prepares security professionals to deploy and manage Cisco Firepower to protect networks against modern threats.",
    learningObjectives: [
      "Install, configure, and manage Cisco Firepower Threat Defence (FTD) appliances.",
      "Configure and tune Next-Generation Firewall (NGFW) and Next-Generation IPS (NGIPS) policies.",
      "Implement advanced access control, SSL decryption, and URL filtering policies.",
      "Monitor Firepower events and generate reports using the Firepower Management Centre (FMC).",
      "Troubleshoot common Firepower deployment and policy issues.",
    ],
    entryRequirements:
      "Candidates should have a working knowledge of TCP/IP networking, familiarity with Cisco ASA firewalls, and a basic understanding of cybersecurity concepts.",
    programRequirements: [
      { label: "Qualification Level:", value: "Professional-Level Cisco Security Training" },
      { label: "Duration:", value: "3 to 5 days (intensive) or 4 to 8 weeks (extended)" },
      { label: "Study Options:", value: "Instructor-Led (classroom or virtual)" },
      { label: "Prerequisites:", value: "TCP/IP knowledge, familiarity with Cisco ASA, and basic security concepts required." },
    ],
  },

  "ciscooperatingsys": {
    description:
      "Cisco Operating Systems training covers the Cisco IOS (Internetwork Operating System) and NX-OS platforms used to manage and configure Cisco routers, switches, and data centre devices. This training provides hands-on experience with CLI-based configuration, management, and troubleshooting of Cisco network infrastructure.",
    learningObjectives: [
      "Navigate and use the Cisco IOS and NX-OS command-line interface (CLI) effectively.",
      "Configure and verify interfaces, VLANs, and routing protocols on Cisco IOS devices.",
      "Manage device security, access control, and software upgrades on Cisco platforms.",
      "Troubleshoot common IOS and NX-OS configuration and connectivity issues.",
      "Understand the differences between Cisco IOS, IOS XE, IOS XR, and NX-OS platforms.",
    ],
    entryRequirements:
      "A foundational understanding of networking concepts is required. CCNA-level knowledge or equivalent experience with Cisco devices is recommended.",
    programRequirements: [
      { label: "Qualification Level:", value: "Foundational to Intermediate Professional Development" },
      { label: "Duration:", value: "3 to 10 days depending on specific focus area" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "Basic networking knowledge; CCNA or equivalent experience recommended." },
    ],
  },

  "ciscoprogramming": {
    description:
      "Cisco DevNet training prepares network engineers and software developers for the era of network programmability and automation. Through the DevNet Associate and Professional certifications, candidates learn to develop applications, automate network operations, and leverage Cisco APIs, platforms, and SDKs to build modern network solutions.",
    learningObjectives: [
      "Develop software applications and scripts using Python to automate network operations.",
      "Use Cisco APIs, SDKs, and DevNet platforms including Cisco DNA Centre, Meraki, and Webex.",
      "Implement CI/CD pipelines and DevOps practices in a network engineering context.",
      "Understand infrastructure as code (IaC) principles and apply them using tools like Terraform and Ansible.",
      "Design and build network automation solutions using model-driven programmability (YANG, RESTCONF, NETCONF).",
    ],
    entryRequirements:
      "Basic programming knowledge (Python preferred) and a foundational understanding of networking are recommended for DevNet Associate. DevNet Professional requires deeper programming and networking experience.",
    programRequirements: [
      { label: "Qualification Level:", value: "Associate to Professional-Level Cisco Certification" },
      { label: "Duration:", value: "3 to 6 months" },
      { label: "Study Options:", value: "Online Self-Paced or Instructor-Led" },
      { label: "Prerequisites:", value: "Basic Python programming and networking knowledge recommended." },
    ],
  },

  // ─────────────────────────────────────────────
  // MICROSOFT
  // ─────────────────────────────────────────────

  "microsoft365": {
    description:
      "The Microsoft 365 Fundamentals (MS-900) certification provides foundational knowledge of the considerations and benefits of adopting cloud services and the Software as a Service (SaaS) cloud model. It covers Microsoft 365 productivity solutions, collaboration features, security, compliance, privacy, and trust. This certification is ideal for anyone seeking to demonstrate knowledge of Microsoft 365.",
    learningObjectives: [
      "Describe the concept of cloud services and Microsoft 365 core services and features.",
      "Explain Microsoft 365 productivity and collaboration solutions including Teams, SharePoint, and Exchange.",
      "Understand security, compliance, privacy, and trust in Microsoft 365.",
      "Describe the Microsoft 365 pricing, licensing, and support options.",
      "Identify the value of adopting cloud services and transitioning to Microsoft 365.",
    ],
    entryRequirements:
      "There are no formal prerequisites for MS-900. This certification is suitable for IT professionals, business decision makers, and anyone seeking foundational knowledge of Microsoft 365.",
    programRequirements: [
      { label: "Qualification Level:", value: "Foundational Microsoft Certification" },
      { label: "Duration:", value: "1 to 4 weeks" },
      { label: "Study Options:", value: "Self-Paced Online, Instructor-Led, or Microsoft Learn" },
      { label: "Prerequisites:", value: "None. General IT knowledge is helpful but not required." },
    ],
  },

  "microsoftadmin": {
    description:
      "The Microsoft 365 Administrator (MS-102) certification validates the skills required to plan, deploy, manage, and monitor Microsoft 365 tenants and services. Administrators configure and manage Microsoft 365 identity, security, compliance, and supporting technologies. This role is central to ensuring an organisation's Microsoft 365 environment is secure and efficient.",
    learningObjectives: [
      "Plan and implement a Microsoft 365 tenant, including identity and access management.",
      "Manage Microsoft 365 services including Exchange Online, Teams, SharePoint, and OneDrive.",
      "Implement and manage Microsoft 365 security policies and threat protection.",
      "Configure Microsoft 365 compliance features including data loss prevention and information governance.",
      "Monitor, maintain, and troubleshoot Microsoft 365 service health and adoption.",
    ],
    entryRequirements:
      "Candidates should have working experience as a Microsoft 365 administrator and have completed an associate-level Microsoft 365 certification such as MS-700, MS-721, or MD-102.",
    programRequirements: [
      { label: "Qualification Level:", value: "Expert-Level Microsoft Certification" },
      { label: "Duration:", value: "3 to 6 months" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "Experience as Microsoft 365 admin; associate-level M365 certification recommended." },
    ],
  },

  "microsoftaiengineer": {
    description:
      "The Microsoft Azure AI Engineer Associate (AI-102) certification validates skills in building, managing, and deploying AI solutions using Azure AI services, Azure Cognitive Services, and Azure Applied AI services. AI Engineers collaborate with data scientists, data engineers, and solution architects to design and implement intelligent solutions that meet business requirements.",
    learningObjectives: [
      "Plan and manage an Azure AI solution, including responsible AI principles and practices.",
      "Implement computer vision, natural language processing, and conversational AI solutions.",
      "Build and deploy Azure Cognitive Search solutions for intelligent search experiences.",
      "Integrate Azure OpenAI Service and language models into enterprise applications.",
      "Monitor, maintain, and optimise deployed Azure AI solutions for performance and security.",
    ],
    entryRequirements:
      "Candidates should have experience with C#, Python, or JavaScript, and familiarity with Azure fundamentals (AZ-900 level). Understanding of REST APIs and machine learning concepts is beneficial.",
    programRequirements: [
      { label: "Qualification Level:", value: "Associate-Level Microsoft Certification" },
      { label: "Duration:", value: "3 to 6 months" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "Programming experience (Python/C#/JavaScript), Azure fundamentals knowledge, and REST API familiarity." },
    ],
  },

  "microsoftazurefundamentals": {
    description:
      "Microsoft Azure Fundamentals (AZ-900) is a foundational certification for those new to cloud and Azure services. It validates knowledge of cloud concepts, core Azure services, security, privacy, compliance, and Azure pricing and support. AZ-900 is ideal for non-technical professionals, business stakeholders, and those beginning their Azure career journey.",
    learningObjectives: [
      "Describe cloud computing concepts including benefits, types, and service models (IaaS, PaaS, SaaS).",
      "Explain core Azure services including compute, networking, storage, and database solutions.",
      "Describe Azure identity, governance, privacy, and compliance features.",
      "Understand Azure cost management, pricing models, and service level agreements.",
      "Identify Azure management and deployment tools including Azure Portal, CLI, and ARM templates.",
    ],
    entryRequirements:
      "There are no formal prerequisites for AZ-900. This certification is designed for anyone interested in demonstrating foundational knowledge of cloud services and Azure, regardless of technical background.",
    programRequirements: [
      { label: "Qualification Level:", value: "Foundational Microsoft Certification" },
      { label: "Duration:", value: "1 to 4 weeks" },
      { label: "Study Options:", value: "Self-Paced Online, Instructor-Led, or Microsoft Learn" },
      { label: "Prerequisites:", value: "None. Suitable for beginners and non-technical professionals." },
    ],
  },

  "microsoftCOURSES": {
    description:
      "Ikusasa offers the full Microsoft learning pathway, encompassing certifications across Azure, Microsoft 365, Security, Data, AI, and Developer specialisations. Microsoft's globally recognised certifications validate role-based skills for cloud administrators, developers, data engineers, security professionals, and more. Our training programmes align to current Microsoft exam objectives and industry demands.",
    learningObjectives: [
      "Navigate the Microsoft certification pathway from foundational to expert level.",
      "Build in-demand Azure, Microsoft 365, and Dynamics 365 skills for modern cloud roles.",
      "Prepare for role-based Microsoft certifications aligned to your career goals.",
      "Gain hands-on experience through labs, case studies, and real-world scenarios.",
      "Access the latest Microsoft training content aligned to current exam requirements.",
    ],
    entryRequirements:
      "Entry requirements vary by course and certification level. Foundational certifications have no prerequisites, while associate and expert certifications require relevant experience and sometimes prior certifications.",
    programRequirements: [
      { label: "Qualification Level:", value: "Foundational to Expert (varies by course)" },
      { label: "Duration:", value: "1 day to 6 months depending on certification" },
      { label: "Study Options:", value: "Instructor-Led, Self-Paced Online, or Blended Learning" },
      { label: "Prerequisites:", value: "Varies by certification; contact us for guidance on the right pathway." },
    ],
  },

  "microsoftdataandai": {
    description:
      "Microsoft's Data and AI certifications validate skills across the full data and artificial intelligence landscape on Azure, including data engineering, data science, machine learning, and AI solution development. These certifications are designed for data professionals who build scalable, secure, and intelligent data solutions on the Azure platform.",
    learningObjectives: [
      "Design and implement data storage, processing, and analytics solutions on Azure.",
      "Build and operationalise machine learning models using Azure Machine Learning.",
      "Develop and deploy AI solutions using Azure Cognitive Services and OpenAI Service.",
      "Implement data governance and security practices across Azure data services.",
      "Use Azure Synapse Analytics, Databricks, and Data Factory for end-to-end data workflows.",
    ],
    entryRequirements:
      "Candidates should have a background in data engineering, data science, or IT, along with knowledge of SQL, Python, and cloud fundamentals. AZ-900 or DP-900 is beneficial.",
    programRequirements: [
      { label: "Qualification Level:", value: "Associate to Expert Microsoft Certification" },
      { label: "Duration:", value: "3 to 6 months per certification" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "SQL and Python knowledge; cloud fundamentals (AZ-900 or DP-900) recommended." },
    ],
  },

  "microsoftDATAANAASS": {
    description:
      "The Microsoft Power BI Data Analyst Associate (PL-300) certification validates expertise in designing and building scalable data models, cleaning and transforming data, and enabling advanced analytic capabilities using Power BI. Data analysts help businesses make data-driven decisions by designing and delivering powerful visualisations and reports.",
    learningObjectives: [
      "Prepare, profile, and clean data using Power Query in Power BI Desktop and Service.",
      "Model data effectively including creating calculated columns, measures, and relationships using DAX.",
      "Design and build interactive Power BI reports and dashboards for business intelligence.",
      "Configure and publish Power BI datasets and reports to the Power BI Service.",
      "Implement row-level security and manage workspace access and data refresh in Power BI.",
    ],
    entryRequirements:
      "Candidates should have experience with Power BI and understand data modelling concepts. Familiarity with SQL, Excel, and basic analytics concepts is recommended.",
    programRequirements: [
      { label: "Qualification Level:", value: "Associate-Level Microsoft Certification (PL-300)" },
      { label: "Duration:", value: "4 to 12 weeks" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "Experience with Power BI; familiarity with SQL, Excel, and data concepts." },
    ],
  },

  "microsoftdatabaseadmin": {
    description:
      "The Microsoft Azure Database Administrator Associate (DP-300) certification validates skills in implementing and managing operational databases on-premises and in the cloud using Azure data services and SQL Server. Database administrators optimise query performance, manage security, maintain high availability, and monitor and optimise database solutions.",
    learningObjectives: [
      "Plan and implement data platform resources on Azure, including Azure SQL Database and Managed Instance.",
      "Implement a secure environment for Azure SQL and SQL Server databases.",
      "Monitor and optimise operational resources, query performance, and automation tasks.",
      "Plan and implement a high-availability and disaster recovery strategy.",
      "Perform administration by using T-SQL and Azure tools in a hybrid environment.",
    ],
    entryRequirements:
      "Candidates should have experience managing SQL Server or Azure SQL databases and knowledge of T-SQL, Windows Server, and Azure fundamentals. DP-900 is beneficial but not required.",
    programRequirements: [
      { label: "Qualification Level:", value: "Associate-Level Microsoft Certification (DP-300)" },
      { label: "Duration:", value: "4 to 12 weeks" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "SQL Server or Azure SQL experience; T-SQL knowledge; Azure fundamentals." },
    ],
  },

  "microsoftDATAENGINEER": {
    description:
      "The Microsoft Azure Data Engineer Associate (DP-203) certification validates expertise in integrating, transforming, and consolidating data from various structured and unstructured data systems into structures suitable for building analytics solutions. Data engineers design and implement data storage, processing, and security in cloud-scale environments.",
    learningObjectives: [
      "Design and implement data storage solutions using Azure Blob Storage, Data Lake, and Synapse Analytics.",
      "Develop data processing pipelines using Azure Data Factory, Databricks, and Spark.",
      "Implement stream processing solutions using Azure Stream Analytics and Event Hubs.",
      "Apply data security, governance, and compliance practices to Azure data solutions.",
      "Monitor and optimise Azure data engineering solutions for performance and cost efficiency.",
    ],
    entryRequirements:
      "Candidates should have strong knowledge of data processing languages such as SQL, Python, or Scala, and familiarity with Azure data services and cloud concepts. AZ-900 or DP-900 is recommended.",
    programRequirements: [
      { label: "Qualification Level:", value: "Associate-Level Microsoft Certification (DP-203)" },
      { label: "Duration:", value: "4 to 12 weeks" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "SQL, Python, or Scala proficiency; Azure data services knowledge recommended." },
    ],
  },

  "microsoftdesktop": {
    description:
      "The Microsoft Modern Desktop Administrator Associate certification (MD-102) validates the skills required to deploy, configure, protect, manage, and monitor devices and client applications in an enterprise environment. Desktop administrators implement Microsoft Intune, Entra ID, and Windows 365 to enable modern management and endpoint security.",
    learningObjectives: [
      "Deploy Windows client operating systems using modern deployment methods including Autopilot.",
      "Manage identity, compliance, and device configuration using Microsoft Intune.",
      "Implement endpoint protection and security baselines for Windows devices.",
      "Manage and deploy Microsoft 365 Apps and updates across enterprise endpoints.",
      "Monitor, troubleshoot, and maintain devices using Microsoft Endpoint Manager and Defender for Endpoint.",
    ],
    entryRequirements:
      "Candidates should have experience with Windows client OS administration and familiarity with Microsoft 365 services, Active Directory, and networking fundamentals.",
    programRequirements: [
      { label: "Qualification Level:", value: "Associate-Level Microsoft Certification (MD-102)" },
      { label: "Duration:", value: "4 to 8 weeks" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "Windows OS administration experience; familiarity with Active Directory and Microsoft 365." },
    ],
  },

  "microsoftdevop": {
    description:
      "The Microsoft DevOps Engineer Expert (AZ-400) certification validates expertise in designing and implementing DevOps practices for version control, compliance, infrastructure as code, configuration management, build, release, and testing, using Azure technologies. DevOps engineers collaborate across all phases of planning, development, delivery, and operations.",
    learningObjectives: [
      "Design and implement DevOps strategies including branching, versioning, and CI/CD pipelines.",
      "Implement infrastructure as code (IaC) using ARM templates, Bicep, and Terraform.",
      "Manage build and release pipelines using Azure DevOps and GitHub Actions.",
      "Implement container and Kubernetes strategies for Azure-hosted workloads.",
      "Design and implement monitoring and feedback mechanisms for DevOps workflows.",
    ],
    entryRequirements:
      "Candidates must hold either the Azure Administrator Associate (AZ-104) or Azure Developer Associate (AZ-204) certification before taking the AZ-400 exam. At least two years of Azure experience is recommended.",
    programRequirements: [
      { label: "Qualification Level:", value: "Expert-Level Microsoft Certification (AZ-400)" },
      { label: "Duration:", value: "3 to 6 months" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "AZ-104 or AZ-204 certification required; 2+ years of Azure experience." },
    ],
  },

  "microsoftiotdev": {
    description:
      "The Microsoft Azure IoT Developer (AZ-220) certification validates skills in implementing the configuration and coding tasks required to create and maintain the cloud and edge portions of an Azure IoT solution. IoT developers work with device engineers and other team members to deliver secure, scalable, and connected IoT solutions using Azure IoT services.",
    learningObjectives: [
      "Set up and configure Azure IoT Hub and provision IoT devices at scale.",
      "Implement message routing, device management, and device twins in Azure IoT Hub.",
      "Deploy and manage Azure IoT Edge modules and workloads.",
      "Process and analyse IoT data using Azure Stream Analytics, Time Series Insights, and Event Hubs.",
      "Implement IoT solution security including device authentication and data encryption.",
    ],
    entryRequirements:
      "Candidates should have experience with Azure services, programming in C#, Python, or Node.js, and a general understanding of IoT devices and messaging protocols such as MQTT and AMQP.",
    programRequirements: [
      { label: "Qualification Level:", value: "Associate-Level Microsoft Certification (AZ-220)" },
      { label: "Duration:", value: "4 to 10 weeks" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "Azure services experience; C#, Python, or Node.js programming skills; IoT concepts knowledge." },
    ],
  },

  "microsoftmigrationwo": {
    description:
      "Microsoft Azure Migration Workshop training equips IT professionals with the skills to assess, plan, and execute migrations of on-premises workloads to Azure. Using tools like Azure Migrate, Azure Site Recovery, and the Cloud Adoption Framework, participants learn to migrate virtual machines, databases, and web applications to the Azure cloud.",
    learningObjectives: [
      "Assess on-premises infrastructure and identify workloads suitable for cloud migration.",
      "Use Azure Migrate to discover, assess, and migrate servers, databases, and applications.",
      "Plan and execute lift-and-shift migrations using Azure Site Recovery.",
      "Optimise and modernise migrated workloads using Azure-native services.",
      "Implement governance, cost management, and security for migrated Azure workloads.",
    ],
    entryRequirements:
      "Candidates should have a working knowledge of Azure services and on-premises IT infrastructure. AZ-900 or AZ-104 knowledge is recommended.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate Professional Development (Workshop)" },
      { label: "Duration:", value: "3 to 5 days (intensive workshop)" },
      { label: "Study Options:", value: "Instructor-Led (classroom or virtual)" },
      { label: "Prerequisites:", value: "Azure and on-premises infrastructure knowledge; AZ-900 or AZ-104 recommended." },
    ],
  },

  "microsoftmigrationwork": {
    description:
      "The Microsoft AZ-120 (Planning and Administering Microsoft Azure for SAP Workloads) certification validates skills required to migrate and maintain SAP solutions on Microsoft Azure. Professionals learn to plan, implement, and operate SAP HANA, S/4HANA, and other SAP workloads on Azure, leveraging Azure's specialised SAP-certified infrastructure.",
    learningObjectives: [
      "Plan and deploy SAP workloads on Azure, including SAP HANA, S/4HANA, and NetWeaver.",
      "Implement Azure infrastructure components required for SAP solutions including networking and storage.",
      "Configure high availability and disaster recovery for SAP workloads on Azure.",
      "Migrate existing SAP environments to Azure using Microsoft and SAP migration tools.",
      "Monitor and operate SAP workloads on Azure using Azure Monitor and SAP HANA cockpit.",
    ],
    entryRequirements:
      "Candidates should have experience with Azure administration (AZ-104 level) and a solid understanding of SAP solutions, SAP HANA, and SAP application landscapes.",
    programRequirements: [
      { label: "Qualification Level:", value: "Specialty Microsoft Certification (AZ-120)" },
      { label: "Duration:", value: "4 to 8 weeks" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "Azure administration (AZ-104) experience and SAP landscape knowledge required." },
    ],
  },

  "microsoftsecengineer": {
    description:
      "The Microsoft Azure Security Engineer Associate (AZ-500) certification validates skills in implementing security controls and threat protection, managing identity and access, and protecting data, applications, and networks in cloud and hybrid environments. Security engineers partner with architects and administrators to implement secure Azure workloads.",
    learningObjectives: [
      "Manage identity and access using Microsoft Entra ID, including PIM and conditional access.",
      "Implement platform protection including network security, host security, and container security.",
      "Manage security operations using Microsoft Defender for Cloud and Microsoft Sentinel.",
      "Secure data and applications using Azure Key Vault, encryption, and application security.",
      "Configure and monitor Azure security posture using compliance tools and security benchmarks.",
    ],
    entryRequirements:
      "Candidates should have strong practical experience with Azure administration and security, scripting skills, and familiarity with Azure networking, virtualization, and cloud architectures. AZ-104 is recommended.",
    programRequirements: [
      { label: "Qualification Level:", value: "Associate-Level Microsoft Certification (AZ-500)" },
      { label: "Duration:", value: "4 to 10 weeks" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "Azure administration experience (AZ-104 level); scripting and security knowledge required." },
    ],
  },

  "microsoftshap": {
    description:
      "Microsoft SharePoint training covers the implementation, configuration, and administration of Microsoft SharePoint as a collaboration and content management platform. Courses range from foundational SharePoint usage to advanced administration and development, preparing professionals to build and manage SharePoint sites, workflows, and integrations within Microsoft 365.",
    learningObjectives: [
      "Create, configure, and manage SharePoint site collections and sites in Microsoft 365.",
      "Implement SharePoint information architecture including content types, libraries, and metadata.",
      "Configure SharePoint security, permissions, and sharing settings.",
      "Build workflows and automation using SharePoint, Power Automate, and Power Apps.",
      "Administer SharePoint Online including governance, compliance, and hybrid configuration.",
    ],
    entryRequirements:
      "Basic familiarity with Microsoft 365 and Windows is recommended. Administrative courses require experience with Microsoft 365 administration and Active Directory.",
    programRequirements: [
      { label: "Qualification Level:", value: "Foundational to Professional (varies by course)" },
      { label: "Duration:", value: "2 to 10 days depending on course level" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "Microsoft 365 familiarity; Active Directory and M365 admin experience for advanced courses." },
    ],
  },

  "microsoftsolart": {
    description:
      "Microsoft Solar Training covers the integration of Azure IoT, Azure AI, and Power Platform technologies to enable smart energy monitoring and management solutions. This training is tailored for professionals working in renewable energy, smart grid, and sustainability environments who want to leverage Microsoft cloud technologies for solar energy data management and analysis.",
    learningObjectives: [
      "Connect and manage solar energy IoT devices using Azure IoT Hub and IoT Central.",
      "Ingest, store, and analyse solar energy data using Azure Data Services and Power BI.",
      "Build dashboards and alerts for real-time solar energy monitoring and reporting.",
      "Apply AI and machine learning models to optimise solar energy output predictions.",
      "Integrate Microsoft Power Platform solutions for solar energy management workflows.",
    ],
    entryRequirements:
      "A basic understanding of Azure services, IoT concepts, and data analytics is recommended. Prior Azure fundamentals knowledge (AZ-900 level) is beneficial.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate Professional Development" },
      { label: "Duration:", value: "3 to 5 days" },
      { label: "Study Options:", value: "Instructor-Led (classroom or virtual)" },
      { label: "Prerequisites:", value: "Azure fundamentals knowledge; IoT and data analytics familiarity recommended." },
    ],
  },

  "microsoftsqlserver": {
    description:
      "Microsoft SQL Server training covers the administration, development, and optimisation of Microsoft SQL Server databases. Courses encompass database design, T-SQL programming, performance tuning, security management, high availability, and migration to Azure SQL, preparing professionals for on-premises and cloud SQL Server environments.",
    learningObjectives: [
      "Install, configure, and manage Microsoft SQL Server instances and databases.",
      "Write and optimise T-SQL queries, stored procedures, functions, and triggers.",
      "Implement SQL Server security including logins, roles, permissions, and encryption.",
      "Configure and manage SQL Server high availability and disaster recovery solutions.",
      "Migrate SQL Server databases to Azure SQL Database or Azure SQL Managed Instance.",
    ],
    entryRequirements:
      "Basic database concepts and familiarity with Windows Server administration are recommended. Advanced courses require prior SQL Server administration or development experience.",
    programRequirements: [
      { label: "Qualification Level:", value: "Foundational to Advanced Professional Development" },
      { label: "Duration:", value: "3 to 10 days depending on course level" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "Basic database knowledge; Windows Server familiarity recommended. Advanced courses require SQL Server experience." },
    ],
  },

  "microsoftvs": {
    description:
      "Microsoft Visual Studio and development training covers the full Microsoft developer toolchain, including Visual Studio, Visual Studio Code, .NET, C#, and Azure developer services. These courses prepare developers to build, test, debug, and deploy enterprise applications using Microsoft's development ecosystem and cloud-native Azure services.",
    learningObjectives: [
      "Develop applications using C#, .NET, and ASP.NET Core in Visual Studio.",
      "Use Visual Studio debugging, profiling, and testing tools to improve code quality.",
      "Integrate Azure DevOps, GitHub, and CI/CD pipelines into the development workflow.",
      "Build web APIs, microservices, and cloud-native applications targeting Azure.",
      "Apply secure coding practices and use Azure developer services such as App Service and Functions.",
    ],
    entryRequirements:
      "Basic programming experience is required. Familiarity with object-oriented programming concepts and at least one programming language (preferably C#) is recommended.",
    programRequirements: [
      { label: "Qualification Level:", value: "Foundational to Advanced Developer Training" },
      { label: "Duration:", value: "3 to 10 days depending on course level" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "Basic programming experience; OOP concepts and C# familiarity recommended." },
    ],
  },

  "microsoftdevasso": {
    description:
      "The Microsoft Azure Developer Associate (AZ-204) certification validates expertise in designing, building, testing, and maintaining cloud applications and services on Microsoft Azure. Azure developers partner with cloud solution architects, DBAs, and DevOps engineers to implement end-to-end solutions across all phases of development.",
    learningObjectives: [
      "Develop Azure compute solutions using Azure App Service, Functions, and Container Instances.",
      "Implement Azure storage solutions including Blob Storage, Cosmos DB, and Azure SQL.",
      "Implement Azure security including managed identities, Key Vault, and API authentication.",
      "Monitor, troubleshoot, and optimise Azure solutions using Application Insights and logging.",
      "Connect Azure services and third-party services using Azure Service Bus, Event Grid, and API Management.",
    ],
    entryRequirements:
      "Candidates should have 1–2 years of professional development experience and familiarity with Azure. Proficiency in at least one Azure-supported programming language (C#, JavaScript, Python) is required.",
    programRequirements: [
      { label: "Qualification Level:", value: "Associate-Level Microsoft Certification (AZ-204)" },
      { label: "Duration:", value: "4 to 10 weeks" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "1–2 years development experience; Azure familiarity; proficiency in C#, JavaScript, or Python." },
    ],
  },

  // ─────────────────────────────────────────────
  // IBM
  // ─────────────────────────────────────────────

  "ibmdatapower": {
    description:
      "IBM DataPower Gateway training covers the configuration and management of IBM's market-leading enterprise security and integration gateway. DataPower provides a dedicated security appliance for XML, web services, API, and SOA workloads. Participants learn to implement security policies, mediation, routing, and transformation using the DataPower platform.",
    learningObjectives: [
      "Understand the IBM DataPower Gateway architecture and deployment scenarios.",
      "Configure multi-protocol gateway services for XML, REST, and SOAP processing.",
      "Implement security policies including authentication, authorisation, and encryption.",
      "Perform message transformation, routing, and mediation using GatewayScript and XSLT.",
      "Monitor, troubleshoot, and manage IBM DataPower Gateway appliances.",
    ],
    entryRequirements:
      "Candidates should have a working knowledge of XML, web services (SOAP/REST), and networking fundamentals. Prior experience with enterprise integration or API management is beneficial.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate to Advanced Professional Development" },
      { label: "Duration:", value: "3 to 5 days" },
      { label: "Study Options:", value: "Instructor-Led (classroom or virtual)" },
      { label: "Prerequisites:", value: "XML, web services, and networking knowledge required." },
    ],
  },

  "ibmdb2c": {
    description:
      "IBM Db2 training covers the administration, development, and performance tuning of IBM's enterprise relational database management system. From installation and configuration to backup and recovery, SQL development, and high availability, this training prepares database professionals to manage IBM Db2 environments across LUW (Linux, Unix, Windows) and z/OS platforms.",
    learningObjectives: [
      "Install, configure, and administer IBM Db2 database instances and databases.",
      "Develop and optimise SQL queries, stored procedures, and user-defined functions in Db2.",
      "Implement database security including authorisation, roles, and audit policies.",
      "Configure and manage backup, recovery, and high availability in IBM Db2.",
      "Monitor Db2 performance and apply tuning techniques for optimal operation.",
    ],
    entryRequirements:
      "Candidates should have a basic understanding of relational database concepts and SQL. Some courses require prior Db2 administration or SQL development experience.",
    programRequirements: [
      { label: "Qualification Level:", value: "Foundational to Advanced Professional Development" },
      { label: "Duration:", value: "3 to 10 days depending on course level" },
      { label: "Study Options:", value: "Instructor-Led (classroom or virtual)" },
      { label: "Prerequisites:", value: "Relational database concepts and SQL knowledge. Advanced courses require Db2 experience." },
    ],
  },

  "ibmendp": {
    description:
      "IBM Endpoint Manager (now IBM BigFix) training covers the deployment, configuration, and management of IBM's unified endpoint management and security compliance platform. BigFix enables IT teams to continuously monitor and enforce endpoint security, patch management, and software distribution across hundreds of thousands of endpoints in real time.",
    learningObjectives: [
      "Install, configure, and administer IBM BigFix server and relay infrastructure.",
      "Create and deploy fixlets, tasks, and baselines for endpoint remediation and patching.",
      "Implement software distribution and inventory management using IBM BigFix.",
      "Apply compliance policies and security configurations across managed endpoints.",
      "Monitor endpoint health and generate compliance and patch status reports.",
    ],
    entryRequirements:
      "Candidates should have experience with Windows or Linux server administration and a basic understanding of IT security and endpoint management concepts.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate Professional Development" },
      { label: "Duration:", value: "3 to 5 days" },
      { label: "Study Options:", value: "Instructor-Led (classroom or virtual)" },
      { label: "Prerequisites:", value: "Windows or Linux server administration experience; basic IT security knowledge." },
    ],
  },

  "ibmguardium": {
    description:
      "IBM Guardium training covers the implementation and management of IBM's data activity monitoring and database security platform. IBM Guardium helps organisations protect sensitive data, monitor database activity, automate compliance auditing, and detect threats across heterogeneous database environments including on-premises and cloud deployments.",
    learningObjectives: [
      "Install, configure, and administer IBM Guardium collectors, aggregators, and Central Manager.",
      "Create and manage data security policies and access control rules in IBM Guardium.",
      "Monitor database activity and generate audit reports for compliance and security purposes.",
      "Implement vulnerability assessments and data discovery workflows using IBM Guardium.",
      "Integrate IBM Guardium with SIEM platforms and enterprise security ecosystems.",
    ],
    entryRequirements:
      "Candidates should have experience with database administration (SQL, Oracle, or similar) and a basic understanding of security and compliance frameworks.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate to Advanced Professional Development" },
      { label: "Duration:", value: "3 to 5 days" },
      { label: "Study Options:", value: "Instructor-Led (classroom or virtual)" },
      { label: "Prerequisites:", value: "Database administration experience and basic security/compliance knowledge required." },
    ],
  },

  "ibmi": {
    description:
      "IBM i (formerly AS/400) training covers the administration, development, and operations of IBM's integrated enterprise server platform. IBM i combines a powerful operating system, database, middleware, and runtime environment on a single platform, widely used in industries requiring high reliability and security. Training ranges from IBM i fundamentals to advanced administration and RPG development.",
    learningObjectives: [
      "Navigate the IBM i operating system and use the 5250 emulator and IBM Navigator for i.",
      "Manage IBM i user profiles, security objects, and authority management.",
      "Administer IBM i storage, save and restore procedures, and journal management.",
      "Develop applications using RPG IV (RPGLE), CL, and SQL on the IBM i platform.",
      "Configure IBM i network services and connectivity including FTP, SMTP, and TCP/IP.",
    ],
    entryRequirements:
      "IBM i fundamentals courses have no prerequisites. Administrative and development courses require prior experience with IBM i or mainframe environments.",
    programRequirements: [
      { label: "Qualification Level:", value: "Foundational to Advanced Professional Development" },
      { label: "Duration:", value: "3 to 10 days depending on course level" },
      { label: "Study Options:", value: "Instructor-Led (classroom or virtual)" },
      { label: "Prerequisites:", value: "None for fundamentals; IBM i or mainframe experience required for advanced courses." },
    ],
  },

  "ibmitcam": {
    description:
      "IBM ITCAM (Tivoli Composite Application Manager) training covers the deployment, configuration, and use of IBM's application performance management solution. ITCAM provides deep visibility into application performance across distributed and mainframe environments, enabling teams to monitor, diagnose, and resolve application performance issues proactively.",
    learningObjectives: [
      "Install and configure IBM ITCAM agents for monitoring application components.",
      "Monitor application performance metrics and detect performance bottlenecks.",
      "Use IBM Tivoli Enterprise Portal to visualise and analyse application health data.",
      "Create custom situations and alerts for proactive performance management.",
      "Generate and interpret performance reports for capacity planning and incident management.",
    ],
    entryRequirements:
      "Candidates should have experience with IBM Tivoli monitoring tools or IBM ITCAM environments and a basic understanding of enterprise application architectures.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate to Advanced Professional Development" },
      { label: "Duration:", value: "3 to 5 days" },
      { label: "Study Options:", value: "Instructor-Led (classroom or virtual)" },
      { label: "Prerequisites:", value: "IBM Tivoli or ITCAM experience; enterprise application monitoring knowledge." },
    ],
  },

  "ibmblockchain": {
    description:
      "IBM Blockchain training introduces the concepts, architecture, and development of blockchain solutions using the IBM Blockchain Platform, which is built on Hyperledger Fabric. Participants learn to design, build, deploy, and manage enterprise-grade permissioned blockchain networks for business applications across industries including supply chain, finance, and healthcare.",
    learningObjectives: [
      "Understand blockchain fundamentals including distributed ledger technology, consensus, and smart contracts.",
      "Design and deploy Hyperledger Fabric networks using the IBM Blockchain Platform.",
      "Develop and deploy chaincode (smart contracts) using Go, JavaScript, or Java.",
      "Integrate blockchain networks with enterprise applications and APIs.",
      "Implement identity management, access control, and governance for permissioned blockchain networks.",
    ],
    entryRequirements:
      "Basic programming knowledge (JavaScript, Go, or Java) and familiarity with cloud services or distributed systems are recommended. No prior blockchain experience is required.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate Professional Development" },
      { label: "Duration:", value: "3 to 5 days or equivalent online modules" },
      { label: "Study Options:", value: "Instructor-Led or IBM Skills Network Online" },
      { label: "Prerequisites:", value: "Basic programming knowledge (JavaScript, Go, or Java); cloud or distributed systems familiarity." },
    ],
  },

  "ibmpowersystem": {
    description:
      "IBM Power Systems training covers the installation, configuration, administration, and troubleshooting of IBM's enterprise-class server platform, including POWER9 and POWER10 systems. Courses address hardware management, virtualisation using IBM PowerVM, AIX administration, Linux on Power, and IBM i, preparing professionals to manage IBM Power Systems environments.",
    learningObjectives: [
      "Install, configure, and manage IBM Power Systems hardware and firmware.",
      "Implement IBM PowerVM virtualisation including LPARs, VIO servers, and live partition mobility.",
      "Administer AIX and Linux operating systems on IBM Power Systems infrastructure.",
      "Monitor system performance and conduct capacity planning for IBM Power Systems.",
      "Implement backup, recovery, and high availability strategies for IBM Power Systems.",
    ],
    entryRequirements:
      "Candidates should have experience with AIX, Linux, or IBM i administration, and a basic understanding of server hardware and virtualisation concepts.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate to Advanced Professional Development" },
      { label: "Duration:", value: "3 to 10 days depending on course" },
      { label: "Study Options:", value: "Instructor-Led (classroom or virtual)" },
      { label: "Prerequisites:", value: "AIX, Linux, or IBM i experience; server hardware and virtualisation knowledge." },
    ],
  },

  "ibmsystemx": {
    description:
      "IBM System x (now Lenovo ThinkSystem) training covers the installation, configuration, and management of IBM x86-based rack and tower servers. Courses cover hardware components, firmware management, RAID configuration, server virtualisation, and integration with IBM systems management tools for enterprise data centre environments.",
    learningObjectives: [
      "Install and configure IBM System x server hardware including components and firmware.",
      "Configure RAID levels and storage subsystems for performance and redundancy.",
      "Implement server virtualisation using VMware and Hyper-V on IBM System x platforms.",
      "Use IBM Systems Director and IMM2 for server management and health monitoring.",
      "Troubleshoot common IBM System x hardware and firmware issues.",
    ],
    entryRequirements:
      "Candidates should have experience with x86 server hardware administration and a basic understanding of networking and storage concepts.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate Professional Development" },
      { label: "Duration:", value: "3 to 5 days" },
      { label: "Study Options:", value: "Instructor-Led (classroom or virtual)" },
      { label: "Prerequisites:", value: "x86 server hardware experience; networking and storage fundamentals." },
    ],
  },

  "ibmsystemstore": {
    description:
      "IBM System Storage training covers the planning, implementation, and administration of IBM's enterprise storage solutions, including IBM Spectrum Storage, IBM FlashSystem, IBM Storwize, and IBM DS8900F. Participants learn to design, configure, and manage storage environments to deliver high availability, performance, and data protection.",
    learningObjectives: [
      "Plan and implement IBM storage solutions including SAN, NAS, and flash storage systems.",
      "Configure IBM Storwize and FlashSystem volumes, pools, and replication features.",
      "Implement IBM Spectrum Storage software for storage virtualisation and management.",
      "Apply storage security, zoning, and access controls in IBM storage environments.",
      "Monitor storage performance and implement capacity planning for IBM storage systems.",
    ],
    entryRequirements:
      "Candidates should have a background in storage administration or data centre operations and familiarity with SAN, NAS, and RAID concepts.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate to Advanced Professional Development" },
      { label: "Duration:", value: "3 to 5 days" },
      { label: "Study Options:", value: "Instructor-Led (classroom or virtual)" },
      { label: "Prerequisites:", value: "Storage administration background; SAN, NAS, and RAID knowledge recommended." },
    ],
  },

  "ibmtrivovistore": {
    description:
      "IBM Tivoli Storage Manager (now IBM Spectrum Protect) training covers the installation, configuration, and administration of IBM's enterprise data protection and storage management platform. Participants learn to design and manage backup, archive, space management, and disaster recovery solutions using IBM Spectrum Protect in complex enterprise environments.",
    learningObjectives: [
      "Install and configure IBM Spectrum Protect (Tivoli Storage Manager) server and clients.",
      "Define storage pools, domains, policies, and schedules for data protection operations.",
      "Implement backup and recovery procedures for physical and virtual environments.",
      "Configure IBM Spectrum Protect for disaster recovery using replication and offsite storage.",
      "Monitor IBM Spectrum Protect server operations and troubleshoot backup failures.",
    ],
    entryRequirements:
      "Candidates should have experience with data centre operations, backup and storage administration, and familiarity with Windows or UNIX/Linux operating systems.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate to Advanced Professional Development" },
      { label: "Duration:", value: "3 to 5 days" },
      { label: "Study Options:", value: "Instructor-Led (classroom or virtual)" },
      { label: "Prerequisites:", value: "Data centre or storage administration experience; Windows/Linux OS knowledge." },
    ],
  },

  "ibmwebsphereappserver": {
    description:
      "IBM WebSphere Application Server (WAS) training covers the installation, configuration, administration, and troubleshooting of IBM's enterprise Java EE application server platform. Participants learn to deploy, manage, and optimise Java applications on WebSphere Application Server, including clustering, security, performance tuning, and migration to Liberty and IBM Cloud.",
    learningObjectives: [
      "Install and configure IBM WebSphere Application Server and Network Deployment environments.",
      "Deploy and manage Java EE applications on WebSphere Application Server.",
      "Configure WebSphere security including SSL, LDAP, and application-level security.",
      "Implement clustering and high availability for WebSphere Application Server environments.",
      "Monitor, performance-tune, and troubleshoot WebSphere Application Server instances.",
    ],
    entryRequirements:
      "Candidates should have experience with Java application deployment and administration, and a working knowledge of Linux or Windows server administration.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate to Advanced Professional Development" },
      { label: "Duration:", value: "3 to 5 days" },
      { label: "Study Options:", value: "Instructor-Led (classroom or virtual)" },
      { label: "Prerequisites:", value: "Java application deployment experience; Linux or Windows server administration knowledge." },
    ],
  },

  "ibmwebspheremb": {
    description:
      "IBM WebSphere Message Broker (now IBM App Connect Enterprise) training covers the design, development, and administration of message-based integration solutions. Participants learn to build message flows to route, transform, and enrich messages between enterprise applications using IBM App Connect Enterprise's extensive protocol and format support.",
    learningObjectives: [
      "Design and develop IBM App Connect Enterprise (ACE) message flows for enterprise integration.",
      "Implement data transformation using ESQL, Java, and graphical mapping tools.",
      "Configure broker infrastructure including integration nodes, servers, and policies.",
      "Implement error handling, logging, and monitoring for integration solutions.",
      "Deploy, test, and maintain integration solutions in development and production environments.",
    ],
    entryRequirements:
      "Candidates should have experience with enterprise application integration concepts, familiarity with XML and ESQL, and a basic understanding of messaging systems.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate to Advanced Professional Development" },
      { label: "Duration:", value: "3 to 5 days" },
      { label: "Study Options:", value: "Instructor-Led (classroom or virtual)" },
      { label: "Prerequisites:", value: "Enterprise integration knowledge; XML and ESQL familiarity; messaging systems understanding." },
    ],
  },

  "ibmwebspheremq": {
    description:
      "IBM WebSphere MQ (now IBM MQ) training covers the installation, configuration, administration, and troubleshooting of IBM's enterprise messaging middleware. IBM MQ ensures reliable, once-and-only-once message delivery between applications across multiple platforms and environments, forming the backbone of enterprise integration and event-driven architectures.",
    learningObjectives: [
      "Install and configure IBM MQ queue managers and communication channels.",
      "Define and manage IBM MQ objects including queues, channels, and listeners.",
      "Implement IBM MQ security including channel authentication records and TLS.",
      "Configure IBM MQ high availability and clustering for enterprise messaging environments.",
      "Monitor IBM MQ performance and troubleshoot messaging connectivity and delivery issues.",
    ],
    entryRequirements:
      "Candidates should have experience with middleware administration and a basic understanding of messaging concepts, TCP/IP networking, and either Windows or Linux administration.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate to Advanced Professional Development" },
      { label: "Duration:", value: "3 to 5 days" },
      { label: "Study Options:", value: "Instructor-Led (classroom or virtual)" },
      { label: "Prerequisites:", value: "Middleware or messaging administration experience; TCP/IP and OS (Windows/Linux) knowledge." },
    ],
  },

  // ─────────────────────────────────────────────
  // ITIL
  // ─────────────────────────────────────────────

  "itil": {
    description:
      "ITIL 4 Foundation is the entry-level certification for the ITIL 4 framework, providing a comprehensive introduction to IT service management concepts. ITIL 4 represents a major update to the ITIL framework, introducing the Service Value System (SVS), the Four Dimensions Model, and 34 practices for holistic IT service management. This certification is globally recognised and essential for IT service management professionals.",
    learningObjectives: [
      "Understand key concepts of ITIL 4 including the Service Value System (SVS) and Service Value Chain.",
      "Apply the four dimensions of service management: organisations and people, information and technology, partners and suppliers, and value streams and processes.",
      "Identify and describe the seven guiding principles of ITIL 4.",
      "Understand the purpose and key terms of 15 ITIL 4 practices.",
      "Demonstrate how ITIL 4 concepts support digital transformation and DevOps environments.",
    ],
    entryRequirements:
      "There are no formal prerequisites for the ITIL 4 Foundation certification. It is suitable for anyone interested in IT service management, including IT professionals and business managers.",
    programRequirements: [
      { label: "Qualification Level:", value: "Foundation-Level ITIL Certification" },
      { label: "Duration:", value: "2 to 3 days (instructor-led) or 4 to 6 weeks (self-paced)" },
      { label: "Study Options:", value: "Instructor-Led, Self-Paced Online, or Blended Learning" },
      { label: "Prerequisites:", value: "None. Suitable for all IT professionals and business stakeholders." },
    ],
  },

  // ─────────────────────────────────────────────
  // POPIA
  // ─────────────────────────────────────────────

  "popia": {
    description:
      "The Protection of Personal Information Act (POPIA) compliance training equips South African organisations and their staff with the knowledge required to comply with South Africa's data protection legislation. POPIA regulates the processing of personal information and imposes obligations on all public and private bodies. This training covers the eight conditions for lawful processing, data subject rights, and practical compliance implementation.",
    learningObjectives: [
      "Understand the scope, purpose, and key provisions of the Protection of Personal Information Act (POPIA).",
      "Apply the eight conditions for the lawful processing of personal information.",
      "Identify the rights of data subjects and the obligations of responsible parties and operators.",
      "Implement a POPIA compliance programme including privacy policies, security safeguards, and incident response.",
      "Understand the role of the Information Regulator and the consequences of POPIA non-compliance.",
    ],
    entryRequirements:
      "No formal prerequisites are required. This training is suitable for all employees, managers, compliance officers, and executives in South African organisations handling personal information.",
    programRequirements: [
      { label: "Qualification Level:", value: "Professional Compliance Training (Non-NQF)" },
      { label: "Duration:", value: "1 to 2 days" },
      { label: "Study Options:", value: "Instructor-Led, Online Self-Paced, or In-House Corporate Training" },
      { label: "Prerequisites:", value: "None. Suitable for all staff in organisations subject to POPIA." },
    ],
  },

  // ─────────────────────────────────────────────
  // CERTNEXUS
  // ─────────────────────────────────────────────

  "certnexus": {
    description:
      "CertNexus is a vendor-neutral IT certification body offering credentials in emerging technology domains including AI, cybersecurity, data science, and IoT. CertNexus certifications are designed for IT professionals who need validated, vendor-neutral skills to operate in today's rapidly evolving technology landscape. Ikusasa offers the full CertNexus certification portfolio.",
    learningObjectives: [
      "Understand CertNexus's role in validating emerging technology skills across AI, security, and data domains.",
      "Identify the CertNexus certification pathway relevant to your career goals.",
      "Explore foundational and professional-level CertNexus certifications in your area of interest.",
      "Understand how CertNexus certifications complement vendor-specific credentials.",
      "Prepare for a career in AI, cybersecurity, data science, or IoT with globally recognised credentials.",
    ],
    entryRequirements:
      "Entry requirements vary by specific CertNexus certification. Foundational courses have no prerequisites, while professional certifications may require relevant work experience or prior certifications.",
    programRequirements: [
      { label: "Qualification Level:", value: "Foundational to Professional (varies by certification)" },
      { label: "Duration:", value: "2 days to 3 months depending on certification" },
      { label: "Study Options:", value: "Instructor-Led or Self-Paced Online" },
      { label: "Prerequisites:", value: "Varies by certification; contact us for guidance." },
    ],
  },

  "certnexusai": {
    description:
      "The CertNexus Artificial Intelligence for Educators (AIE) credential equips educators and trainers with the knowledge and skills to understand, apply, and teach AI concepts effectively. This certification addresses the growing demand for AI literacy among educators and training professionals, covering AI fundamentals, ethical AI, and practical AI applications in learning environments.",
    learningObjectives: [
      "Understand foundational AI concepts including machine learning, deep learning, and natural language processing.",
      "Apply responsible AI principles and recognise bias, fairness, and ethical considerations in AI systems.",
      "Identify appropriate AI tools and platforms for educational and training applications.",
      "Design learning experiences that incorporate AI technologies for enhanced outcomes.",
      "Evaluate AI-driven tools and assess their suitability for educational use cases.",
    ],
    entryRequirements:
      "This certification is designed for educators, trainers, and instructional designers. Basic IT literacy is recommended. No prior AI or data science experience is required.",
    programRequirements: [
      { label: "Qualification Level:", value: "Foundational Professional Certification" },
      { label: "Duration:", value: "2 to 3 days" },
      { label: "Study Options:", value: "Instructor-Led or Online Self-Paced" },
      { label: "Prerequisites:", value: "None. Basic IT literacy recommended. Designed for educators and training professionals." },
    ],
  },

  "certnexuscybersec": {
    description:
      "The CertNexus CyberSec First Responder (CFR) certification validates skills required to assess and respond to cybersecurity threats at the first-responder level. CFR is designed for cybersecurity professionals who need to identify, protect against, detect, respond to, and recover from cybersecurity incidents. It is aligned with NIST, NICE, and DoD frameworks.",
    learningObjectives: [
      "Assess and identify cybersecurity threats, vulnerabilities, and risk to enterprise environments.",
      "Collect and analyse cyber threat intelligence from multiple sources.",
      "Perform active defence techniques and implement incident response procedures.",
      "Investigate, contain, and recover from cybersecurity incidents using forensic principles.",
      "Apply compliance frameworks and security standards to organisational cybersecurity operations.",
    ],
    entryRequirements:
      "Candidates should have at least two years of experience in computer network security, along with knowledge of TCP/IP networking, operating systems, and security concepts. CompTIA Security+ or equivalent is recommended.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate Professional Certification" },
      { label: "Duration:", value: "4 to 5 days (instructor-led) or 6 to 10 weeks (self-paced)" },
      { label: "Study Options:", value: "Instructor-Led or Online Self-Paced" },
      { label: "Prerequisites:", value: "2 years of network security experience; Security+ or equivalent recommended." },
    ],
  },

  "certnexusdatascience": {
    description:
      "The CertNexus Data Science Foundations (DSF) certification validates foundational knowledge and skills in data science, including data collection, analysis, visualisation, and machine learning concepts. DSF is designed for professionals beginning their data science journey and provides a vendor-neutral foundation for further specialisation in data analytics and AI.",
    learningObjectives: [
      "Understand the data science process, methodologies, and the role of a data scientist.",
      "Collect, clean, and prepare datasets for analysis using industry-standard tools.",
      "Apply statistical analysis and data visualisation techniques to interpret data.",
      "Implement foundational machine learning algorithms including classification, regression, and clustering.",
      "Communicate data findings effectively through visualisations and data storytelling.",
    ],
    entryRequirements:
      "A basic understanding of mathematics and statistics is recommended. No prior programming or data science experience is required for the foundational certification.",
    programRequirements: [
      { label: "Qualification Level:", value: "Foundational Professional Certification" },
      { label: "Duration:", value: "2 to 3 days" },
      { label: "Study Options:", value: "Instructor-Led or Online Self-Paced" },
      { label: "Prerequisites:", value: "None. Basic mathematics and statistics knowledge helpful." },
    ],
  },

  "certnexusiot": {
    description:
      "The CertNexus IoT Security (ITS) certification validates skills in securing IoT devices, networks, and data within enterprise IoT deployments. As IoT adoption accelerates across industries, securing connected devices and the data they generate is critical. ITS equips professionals with the knowledge to assess IoT risks and implement appropriate security controls.",
    learningObjectives: [
      "Identify IoT architecture components and understand IoT security risks and threat vectors.",
      "Apply security principles to IoT device design, firmware, and communication protocols.",
      "Implement network segmentation, access control, and encryption for IoT environments.",
      "Monitor IoT deployments for anomalies and respond to IoT security incidents.",
      "Assess IoT solutions for compliance with security standards and regulatory requirements.",
    ],
    entryRequirements:
      "Candidates should have a basic understanding of networking, security concepts, and IoT fundamentals. CompTIA Security+ or equivalent knowledge is beneficial.",
    programRequirements: [
      { label: "Qualification Level:", value: "Intermediate Professional Certification" },
      { label: "Duration:", value: "2 to 3 days" },
      { label: "Study Options:", value: "Instructor-Led or Online Self-Paced" },
      { label: "Prerequisites:", value: "Basic networking and security knowledge; Security+ equivalent beneficial." },
    ],
  },

  // ─────────────────────────────────────────────
  // MICT SETA
  // ─────────────────────────────────────────────

  "mictset": {
    description:
      "MICT SETA (Media, Information and Communication Technologies Sector Education and Training Authority) qualifications are South African National Qualifications Framework (NQF) accredited programmes designed to develop ICT skills for the South African workforce. These qualifications range from NQF Level 4 (Technical Support) to NQF Level 5 (Systems Development and Support), providing learners with industry-recognised credentials aligned to SAQA standards.",
    learningObjectives: [
      "Develop foundational to advanced ICT competencies aligned to NQF Level 4 and Level 5 outcomes.",
      "Apply technical support, infrastructure, web development, and application development skills in real-world scenarios.",
      "Build an ICT portfolio of evidence demonstrating competencies required for NQF assessment.",
      "Prepare for employment in the South African ICT sector with MICT SETA-recognised qualifications.",
      "Access learnership and skills development opportunities funded through MICT SETA.",
    ],
    entryRequirements:
      "Entry requirements vary by NQF level. NQF Level 4 programmes typically require a Grade 10 or equivalent qualification, while NQF Level 5 programmes require a Grade 12 or NQF Level 4 qualification.",
    programRequirements: [
      { label: "Qualification Level:", value: "NQF Level 4 to NQF Level 5" },
      { label: "Duration:", value: "12 to 18 months (learnership format)" },
      { label: "Study Options:", value: "Part-Time, Learnership, or Full-Time" },
      { label: "Prerequisites:", value: "Grade 10 minimum for NQF Level 4; Grade 12 or NQF Level 4 for NQF Level 5." },
    ],
  },

  "mictseta": {
    description:
      "MICT SETA qualifications cover a broad range of ICT disciplines including website development, infrastructure development, application development, system support, and end-user training. All qualifications are registered on the South African National Qualifications Framework (NQF) and accredited by MICT SETA, providing learners with nationally recognised credentials that open pathways to employment and further education in the ICT sector.",
    learningObjectives: [
      "Develop practical ICT skills across web development, infrastructure, application development, and support disciplines.",
      "Apply end-user computing and technical support skills in South African workplace environments.",
      "Complete portfolio of evidence (PoE) assessments demonstrating competency for NQF certification.",
      "Understand South African ICT industry standards, workplace practices, and professional conduct.",
      "Access further education and career development pathways through MICT SETA-recognised qualifications.",
    ],
    entryRequirements:
      "Entry requirements vary by programme. Most MICT SETA programmes require at minimum a Grade 10 (for NQF Level 4) or Grade 12/NQF Level 4 (for NQF Level 5). Basic computer literacy is essential.",
    programRequirements: [
      { label: "Qualification Level:", value: "NQF Level 3 to NQF Level 5 (varies by programme)" },
      { label: "Duration:", value: "6 months to 18 months depending on programme" },
      { label: "Study Options:", value: "Learnership, Part-Time, or Full-Time" },
      { label: "Prerequisites:", value: "Grade 10 minimum (NQF Level 4); Grade 12 or NQF Level 4 (NQF Level 5). Basic computer literacy required." },
    ],
  },

  // ─────────────────────────────────────────────
  // SOFT SKILLS
  // ─────────────────────────────────────────────

  "softskillsbusinesscourses": {
    description:
      "Business skills training equips professionals with the essential competencies required to operate effectively in modern organisational environments. These courses cover business communication, report writing, business etiquette, time management, problem-solving, and critical thinking, providing participants with skills that enhance productivity and professional impact across all industries.",
    learningObjectives: [
      "Communicate effectively in business contexts through written, verbal, and digital channels.",
      "Apply professional business writing skills for reports, emails, and presentations.",
      "Use time management and prioritisation frameworks to improve personal productivity.",
      "Apply critical thinking and structured problem-solving approaches to business challenges.",
      "Demonstrate professional business etiquette and conduct in the workplace.",
    ],
    entryRequirements:
      "No formal prerequisites are required. These courses are suitable for professionals at all career stages who want to enhance their business competencies.",
    programRequirements: [
      { label: "Qualification Level:", value: "Non-Formal Professional Development" },
      { label: "Duration:", value: "1 to 5 days depending on specific course" },
      { label: "Study Options:", value: "Instructor-Led, Online Self-Paced, or In-House Corporate Training" },
      { label: "Prerequisites:", value: "None. Open to all professional levels." },
    ],
  },

  "softskillsinterpcourses": {
    description:
      "Interpersonal skills training focuses on the abilities that govern how individuals interact, communicate, and collaborate with others in the workplace. These courses develop competencies in communication, teamwork, conflict resolution, active listening, empathy, and relationship-building, enabling professionals to work more effectively with colleagues, clients, and stakeholders.",
    learningObjectives: [
      "Develop active listening skills and effective verbal and non-verbal communication techniques.",
      "Build and maintain productive professional relationships in diverse workplace environments.",
      "Apply conflict resolution and negotiation strategies to resolve workplace disputes constructively.",
      "Demonstrate empathy, emotional intelligence, and cultural sensitivity in professional interactions.",
      "Collaborate effectively in teams, including remote and cross-functional team environments.",
    ],
    entryRequirements:
      "No formal prerequisites are required. These courses are suitable for all professionals seeking to improve their ability to work effectively with others.",
    programRequirements: [
      { label: "Qualification Level:", value: "Non-Formal Professional Development" },
      { label: "Duration:", value: "1 to 3 days" },
      { label: "Study Options:", value: "Instructor-Led or In-House Corporate Training" },
      { label: "Prerequisites:", value: "None. Suitable for all professional levels." },
    ],
  },

  "softskillsintrapcourses": {
    description:
      "Intrapersonal skills training focuses on the internal competencies that govern how individuals understand and manage themselves, including self-awareness, emotional intelligence, resilience, goal-setting, and personal accountability. Developing intrapersonal skills enables professionals to perform at their best, manage stress effectively, and maintain a growth mindset.",
    learningObjectives: [
      "Develop self-awareness and understand personal strengths, values, and areas for development.",
      "Apply emotional intelligence principles to manage personal emotions and responses effectively.",
      "Build resilience and adaptability to navigate change and workplace challenges.",
      "Set SMART personal and professional goals and develop action plans to achieve them.",
      "Cultivate a growth mindset and personal accountability for continuous professional development.",
    ],
    entryRequirements:
      "No formal prerequisites are required. These courses benefit professionals at all career stages who seek greater self-awareness and personal effectiveness.",
    programRequirements: [
      { label: "Qualification Level:", value: "Non-Formal Professional Development" },
      { label: "Duration:", value: "1 to 2 days" },
      { label: "Study Options:", value: "Instructor-Led or In-House Corporate Training" },
      { label: "Prerequisites:", value: "None. Open to all career levels." },
    ],
  },

  "softskillssalesourses": {
    description:
      "Sales skills training equips sales professionals and business development teams with the techniques, mindset, and tools required to prospect effectively, build client relationships, and close deals. These courses cover the full sales cycle from prospecting and needs analysis to objection handling, negotiation, and account management.",
    learningObjectives: [
      "Apply a structured sales methodology to manage the full sales cycle from prospecting to close.",
      "Conduct effective needs analysis conversations to identify and align with client requirements.",
      "Handle objections professionally and navigate challenging sales conversations with confidence.",
      "Apply negotiation techniques to secure win-win outcomes for clients and the organisation.",
      "Develop account management skills to retain and grow existing client relationships.",
    ],
    entryRequirements:
      "No formal prerequisites are required. These courses are suitable for new and experienced sales professionals, account managers, and business development representatives.",
    programRequirements: [
      { label: "Qualification Level:", value: "Non-Formal Professional Development" },
      { label: "Duration:", value: "1 to 5 days depending on specific course" },
      { label: "Study Options:", value: "Instructor-Led or In-House Corporate Training" },
      { label: "Prerequisites:", value: "None. Suitable for all sales and business development professionals." },
    ],
  },

  "softskillscustomercourses": {
    description:
      "Customer service training develops the skills required to deliver exceptional customer experiences across all touchpoints. These courses cover professional communication, complaint handling, service recovery, customer relationship management, and the principles of a customer-centric culture, enabling organisations to improve customer satisfaction and loyalty.",
    learningObjectives: [
      "Apply customer service principles and best practices to deliver consistently excellent service.",
      "Communicate professionally with customers across telephone, email, and face-to-face channels.",
      "Handle customer complaints and difficult situations with empathy and professionalism.",
      "Implement service recovery strategies to restore customer satisfaction after service failures.",
      "Contribute to a customer-centric organisational culture that prioritises the customer experience.",
    ],
    entryRequirements:
      "No formal prerequisites are required. These courses are suitable for customer-facing staff, call centre agents, service coordinators, and frontline managers.",
    programRequirements: [
      { label: "Qualification Level:", value: "Non-Formal Professional Development" },
      { label: "Duration:", value: "1 to 3 days" },
      { label: "Study Options:", value: "Instructor-Led or In-House Corporate Training" },
      { label: "Prerequisites:", value: "None. Suitable for all customer-facing roles." },
    ],
  },

  "softskillssupercourses": {
    description:
      "Supervisory and management training equips team leaders, supervisors, and first-line managers with the skills to lead teams effectively. These courses cover leadership styles, delegation, performance management, team motivation, meeting facilitation, and people management, providing participants with practical tools to manage their teams with confidence.",
    learningObjectives: [
      "Apply effective leadership styles and adapt your approach to different team and situational contexts.",
      "Delegate tasks effectively and develop team members through coaching and feedback.",
      "Manage team performance through goal-setting, performance reviews, and disciplinary processes.",
      "Facilitate productive team meetings and resolve conflict within the team.",
      "Apply people management skills to motivate, retain, and develop team members.",
    ],
    entryRequirements:
      "No formal qualifications are required. These courses are designed for newly appointed and existing supervisors, team leaders, and first-line managers.",
    programRequirements: [
      { label: "Qualification Level:", value: "Non-Formal Professional Development" },
      { label: "Duration:", value: "2 to 5 days depending on specific course" },
      { label: "Study Options:", value: "Instructor-Led or In-House Corporate Training" },
      { label: "Prerequisites:", value: "None. Designed for supervisors, team leaders, and first-line managers." },
    ],
  },

  "softskillsbusiness": {
    description:
      "Ikusasa's broader soft skills business training portfolio covers a wide range of professional development topics designed to elevate workplace performance at every level of the organisation. From business writing and presentation skills to change management, stakeholder engagement, and project coordination, these programmes build the human capital that drives business success.",
    learningObjectives: [
      "Build a broad base of professional competencies applicable across all business functions and industries.",
      "Develop communication, leadership, and collaboration skills for the modern workplace.",
      "Apply structured approaches to problem-solving, decision-making, and stakeholder management.",
      "Enhance personal effectiveness through productivity, time management, and workplace organisation techniques.",
      "Align individual professional development with organisational performance and culture goals.",
    ],
    entryRequirements:
      "No formal prerequisites are required. Training is tailored to the experience level and specific needs of participants.",
    programRequirements: [
      { label: "Qualification Level:", value: "Non-Formal Professional Development" },
      { label: "Duration:", value: "1 to 5 days depending on programme" },
      { label: "Study Options:", value: "Instructor-Led, Online, or In-House Corporate Training" },
      { label: "Prerequisites:", value: "None. All programmes are tailored to participant experience levels." },
    ],
  },

  "softskillstfcourse": {
    description:
      "Train the Facilitator (TF) programmes equip professionals with the skills to design, deliver, and evaluate effective training and facilitation sessions. These courses cover adult learning principles, facilitation techniques, training needs analysis, programme design, and assessment, preparing participants to facilitate impactful learning experiences in workplace and professional settings.",
    learningObjectives: [
      "Apply adult learning principles and learning theory to design effective training programmes.",
      "Facilitate group learning sessions using a range of interactive facilitation techniques.",
      "Conduct training needs analyses to identify learning gaps and design appropriate interventions.",
      "Develop training materials and resources aligned to learning outcomes.",
      "Assess participant learning and evaluate the effectiveness of training interventions.",
    ],
    entryRequirements:
      "No formal prerequisites are required. These programmes are suitable for HR professionals, trainers, subject matter experts, and anyone responsible for facilitating workplace learning.",
    programRequirements: [
      { label: "Qualification Level:", value: "Non-Formal Professional Development" },
      { label: "Duration:", value: "2 to 5 days" },
      { label: "Study Options:", value: "Instructor-Led" },
      { label: "Prerequisites:", value: "None. Suitable for HR professionals, trainers, and workplace facilitators." },
    ],
  },

  // ─────────────────────────────────────────────
  // PROGRAMME / APPLICATION DEVELOPMENT
  // ─────────────────────────────────────────────

  "programdev": {
    description:
      "Programme and application development training covers the full software development lifecycle, from foundational programming concepts to advanced application development using modern languages, frameworks, and platforms. These courses prepare developers with skills in web development, mobile application development, database-driven applications, and software engineering best practices.",
    learningObjectives: [
      "Apply programming fundamentals including variables, data types, control structures, and functions in one or more languages.",
      "Design and develop web applications using modern front-end and back-end frameworks.",
      "Implement database design and SQL integration within application development projects.",
      "Apply software engineering principles including version control, testing, and agile methodologies.",
      "Build and deploy cloud-native or web-hosted applications using current industry tools and platforms.",
    ],
    entryRequirements:
      "Entry requirements vary by specific programme and language. Introductory courses have no prerequisites. Advanced development courses require prior programming experience and familiarity with development environments.",
    programRequirements: [
      { label: "Qualification Level:", value: "Foundational to Advanced (varies by course)" },
      { label: "Duration:", value: "1 week to 6 months depending on programme" },
      { label: "Study Options:", value: "Instructor-Led, Online Self-Paced, or Blended Learning" },
      { label: "Prerequisites:", value: "Varies by programme. Introductory courses: none. Advanced: prior programming experience required." },
    ],
  },

  // ─────────────────────────────────────────────
  // QCTO
  // ─────────────────────────────────────────────

  "ai-software-developer": {
    description:
      "The Occupational Certificate: Artificial Intelligence Software Developer (NQF Level 5) is a QCTO-accredited qualification offered by Ikusasa Technology Solutions. This programme equips learners with the practical skills and theoretical knowledge required to design, develop, and deploy AI-powered software solutions. Learners will gain hands-on experience with machine learning, data processing, and AI model integration within real-world application environments. The qualification is accredited under accreditation number 07-QCTO/SDP040925150023, valid until August 2030.",
    learningObjectives: [
      "Understand the principles of artificial intelligence, machine learning, and deep learning.",
      "Design and develop software applications that incorporate AI and machine learning models.",
      "Collect, clean, and process data for use in AI and predictive systems.",
      "Evaluate and optimise AI models for accuracy, performance, and ethical use.",
      "Deploy AI solutions into production environments and maintain them effectively.",
      "Apply responsible AI practices including fairness, transparency, and data privacy.",
    ],
    entryRequirements:
      "Applicants should have a Grade 12 (NQF Level 4) or equivalent qualification. A basic understanding of programming and mathematics is recommended. Learners with prior experience in software development or IT support will benefit most from this programme.",
    programRequirements: [
      { label: "Qualification:", value: "Occupational Certificate: AI Software Developer" },
      { label: "NQF Level:", value: "Level 5" },
      { label: "Minimum Credits:", value: "209" },
      { label: "OFO Code:", value: "118792" },
      { label: "Accreditation:", value: "QCTO — 07-QCTO/SDP040925150023" },
      { label: "Duration:", value: "12 to 18 months" },
      { label: "Study Options:", value: "Full-time or Part-time" },
      { label: "Prerequisites:", value: "Grade 12 or equivalent; basic programming knowledge recommended." },
    ],
  },

  "cybersecurity-analyst": {
    description:
      "The Occupational Certificate: Cybersecurity Analyst (NQF Level 5) is a QCTO-accredited qualification that prepares learners to protect organisations from digital threats. Learners develop skills in threat detection, vulnerability assessment, incident response, and security monitoring. This programme is accredited under 07-QCTO/SDP180925105324, valid until September 2030.",
    learningObjectives: [
      "Identify and analyse cybersecurity threats, vulnerabilities, and attack vectors.",
      "Implement security monitoring tools and interpret security event data.",
      "Conduct vulnerability assessments and penetration testing in controlled environments.",
      "Respond to and document security incidents following industry best practices.",
      "Apply legal, ethical, and compliance frameworks relevant to information security in South Africa.",
      "Communicate security risks and recommendations to technical and non-technical stakeholders.",
    ],
    entryRequirements:
      "Grade 12 (NQF Level 4) or equivalent. A foundational understanding of IT networking and operating systems is recommended. Learners with CompTIA A+ or Network+ background will benefit most.",
    programRequirements: [
      { label: "Qualification:", value: "Occupational Certificate: Cybersecurity Analyst" },
      { label: "NQF Level:", value: "Level 5" },
      { label: "Minimum Credits:", value: "173" },
      { label: "OFO Code:", value: "118986" },
      { label: "Accreditation:", value: "QCTO — 07-QCTO/SDP180925105324" },
      { label: "Duration:", value: "12 to 18 months" },
      { label: "Study Options:", value: "Full-time or Part-time" },
      { label: "Prerequisites:", value: "Grade 12 or equivalent; basic IT networking knowledge recommended." },
    ],
  },

  "data-science-practitioner": {
    description:
      "The Occupational Certificate: Data Science Practitioner (NQF Level 5) equips learners with the skills to collect, process, analyse, and visualise data to support business decision-making. Learners work with real-world datasets, statistical methods, and machine learning fundamentals. Accredited by QCTO under 07-QCTO/SDP180925105324, valid until September 2030.",
    learningObjectives: [
      "Collect, clean, and preprocess structured and unstructured datasets.",
      "Apply statistical analysis and exploratory data analysis (EDA) techniques.",
      "Build and evaluate basic machine learning models for classification and prediction.",
      "Visualise data insights using tools such as Python, R, or Power BI.",
      "Interpret and communicate data findings to support business decisions.",
      "Understand data governance, ethics, and privacy regulations applicable in South Africa.",
    ],
    entryRequirements:
      "Grade 12 (NQF Level 4) or equivalent with Mathematics. A basic understanding of programming or spreadsheets is advantageous. No prior data science experience required.",
    programRequirements: [
      { label: "Qualification:", value: "Occupational Certificate: Data Science Practitioner" },
      { label: "NQF Level:", value: "Level 5" },
      { label: "Minimum Credits:", value: "185" },
      { label: "OFO Code:", value: "118708" },
      { label: "Accreditation:", value: "QCTO — 07-QCTO/SDP180925105324" },
      { label: "Duration:", value: "12 to 18 months" },
      { label: "Study Options:", value: "Full-time or Part-time" },
      { label: "Prerequisites:", value: "Grade 12 with Maths; basic programming or spreadsheet knowledge advantageous." },
    ],
  },

  "cloud-administrator": {
    description:
      "The Occupational Certificate: Cloud Administrator (NQF Level 4) develops the practical skills needed to deploy, manage, and maintain cloud infrastructure on platforms such as Microsoft Azure, AWS, or Google Cloud. Learners gain hands-on experience with cloud services, networking, storage, and security in cloud environments. Accredited under 07-QCTO/SDP180925105324, valid until September 2030.",
    learningObjectives: [
      "Understand cloud computing models (IaaS, PaaS, SaaS) and major cloud platforms.",
      "Deploy and configure virtual machines, storage, and networking in a cloud environment.",
      "Manage user access, identity, and permissions using cloud IAM tools.",
      "Monitor cloud infrastructure performance and respond to availability issues.",
      "Implement basic cloud security controls and compliance policies.",
      "Manage costs and optimise cloud resource utilisation.",
    ],
    entryRequirements:
      "Grade 12 (NQF Level 4) or equivalent. Basic computer literacy and an understanding of networking fundamentals are recommended. No prior cloud experience is required.",
    programRequirements: [
      { label: "Qualification:", value: "Occupational Certificate: Cloud Administrator" },
      { label: "NQF Level:", value: "Level 4" },
      { label: "Minimum Credits:", value: "149" },
      { label: "OFO Code:", value: "118699" },
      { label: "Accreditation:", value: "QCTO — 07-QCTO/SDP180925105324" },
      { label: "Duration:", value: "10 to 12 months" },
      { label: "Study Options:", value: "Full-time or Part-time" },
      { label: "Prerequisites:", value: "Grade 12; basic computer literacy and networking understanding recommended." },
    ],
  },

  "computer-technician": {
    description:
      "The Occupational Certificate: Computer Technician (NQF Level 5) provides comprehensive training in the installation, configuration, maintenance, and repair of computer hardware and software systems. Learners develop the technical expertise to support end-users and maintain IT infrastructure in business environments. Accredited under 07-QCTO/SDP180925105324, valid until September 2030.",
    learningObjectives: [
      "Install, configure, and troubleshoot computer hardware components and peripherals.",
      "Set up and maintain operating systems including Windows and Linux environments.",
      "Diagnose and resolve hardware and software faults systematically.",
      "Configure and support local area networks (LAN) and internet connectivity.",
      "Implement basic security measures including antivirus, patching, and user access controls.",
      "Provide professional IT support and maintain accurate technical documentation.",
    ],
    entryRequirements:
      "Grade 12 (NQF Level 4) or equivalent. Basic computer literacy is required. Learners with a CompTIA A+ background or practical IT experience will be well-prepared.",
    programRequirements: [
      { label: "Qualification:", value: "Occupational Certificate: Computer Technician" },
      { label: "NQF Level:", value: "Level 5" },
      { label: "Minimum Credits:", value: "282" },
      { label: "OFO Code:", value: "101408" },
      { label: "Accreditation:", value: "QCTO — 07-QCTO/SDP180925105324" },
      { label: "Duration:", value: "18 to 24 months" },
      { label: "Study Options:", value: "Full-time or Part-time" },
      { label: "Prerequisites:", value: "Grade 12; basic computer literacy required." },
    ],
  },

  "software-engineer": {
    description:
      "The Occupational Certificate: Software Engineer (NQF Level 6) is a comprehensive QCTO-accredited qualification that trains learners to design, develop, test, and maintain software systems. Covering the full software development lifecycle, learners gain proficiency in programming, systems design, databases, and agile development methodologies. Accredited under 07-QCTO/SDP180925105324, valid until September 2030.",
    learningObjectives: [
      "Design and develop software applications using industry-standard programming languages.",
      "Apply object-oriented programming (OOP) principles and software design patterns.",
      "Build, query, and manage relational and non-relational databases.",
      "Implement software testing strategies including unit, integration, and system testing.",
      "Work within agile development frameworks such as Scrum to deliver software iteratively.",
      "Deploy and maintain software applications in production environments.",
    ],
    entryRequirements:
      "Grade 12 (NQF Level 4) with Mathematics, or an NQF Level 4/5 qualification in IT or a related field. Prior programming experience or completion of an entry-level IT qualification is strongly recommended.",
    programRequirements: [
      { label: "Qualification:", value: "Occupational Certificate: Software Engineer" },
      { label: "NQF Level:", value: "Level 6" },
      { label: "Minimum Credits:", value: "240" },
      { label: "OFO Code:", value: "119458" },
      { label: "Accreditation:", value: "QCTO — 07-QCTO/SDP180925105324" },
      { label: "Duration:", value: "18 to 24 months" },
      { label: "Study Options:", value: "Full-time or Part-time" },
      { label: "Prerequisites:", value: "Grade 12 with Maths; prior programming experience or NQF Level 4/5 IT qualification recommended." },
    ],
  },

};
